import React from 'react';

// Textarea Mui-component
const TextArea = ({ placeholder, value, onChange, background="white", color="black", placeholderColor="gray", ...props }) => {
  // const [multiline, setMultiline] = React.useState(false);
  
  // React.useEffect(() => {
  //   setMultiline(true);
  // }, []);

  // React.useEffect(() => {
  //   const handleWindowResize = () => {
  //     setMultiline(false);
  //     setTimeout(() => {
  //       setMultiline(true);
  //     }, 0);
  //   }

  //   window.addEventListener('resize', handleWindowResize);

  //   return () => window.removeEventListener('resize', handleWindowResize);
  // }, [])

  // return (
  //   <TextField
  //     id="outlined-textarea"
  //     // multiline={multiline}
  //     placeholder={placeholder}
  //     value={value}
  //     onChange={onChange}
  //     variant="outlined"
  //     fullWidth
  //     {...props}
  //     sx={{
  //       '& .MuiOutlinedInput-root': {
  //         fontSize: '13px',
  //         padding: '12px 10px',
  //         backgroundColor: background,
  //         overflowY: 'auto', 
  //         color: color,
  //         scrollbarWidth: 'none', 
  //         '@media (max-width: 500px)': { // Medium screens (e.g., tablets)
  //           padding: '8px 10px',
  //           fontSize: '9px',
  //         },
  //         '&::-webkit-scrollbar': {
  //           display: 'none', 
  //         },
  //         boxSizing: 'border-box', 
  //         '& .MuiOutlinedInput-notchedOutline': {
  //           border: 'none', 
  //         },
  //         '& .MuiInputBase-input::placeholder': {
  //         color: placeholderColor,
  //         opacity: 1,
  //       },
  //       },
  //     }}
  //   />
  // );

  return (
    <textarea
      name={props.name || ""}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      autoComplete='off'
      rows={props.rows}
      {...props}
      className={`${props.className} placeholder:text-[${placeholderColor}] bg-[${background}] m-[8px_6px] text-[9px] screen-500:m-[12px_10px] screen-500:text-[13px]`}
      style={{
        backgroundColor: background,
        color: color,
        border: 'none',
        outline: 'none',
        width : '100%',
        resize: 'none',
      }}
    />
  )
};

export default React.memo(TextArea);
